module.exports = __webpack_public_path__ + "static/media/twin-mirrors-banner.fca2748a.jpg";